import SlimSelect from 'slim-select';
import axios from 'axios';

var ajaxGetProducts = function ajaxGetProducts() {
  var formData = new FormData();
  formData.append('action', "get_ajax_products");
  axios.post(ajaxurl, formData).then(function (res) {
    var data = res.data;
    var postsList = document.querySelector("#products-container");
    postsList.innerHTML = data;
    console.log(res);
  });
};

export var initSelect = function initSelect() {
  var params = window.location.search; // tabs

  var enable = document.querySelector('#perpage');

  if (enable) {
    var perPage = new SlimSelect({
      select: '#perpage',
      showSearch: false
    });
  }

  enable = document.querySelector('.dropdown_layered_nav_zapach');

  if (enable) {
    // const filters = [
    //   '.dropdown_layered_nav_zapach',
    //   '.dropdown_layered_nav_dodatkowa-nuta-zapachowa',
    //   '.dropdown_layered_nav_linia-zapachowa',
    // ];
    var filters = ['.dropdown_layered_nav_zapach'];
    filters.forEach(function (filter) {
      var currentFilter = new SlimSelect({
        select: filter,
        showSearch: false
      }); // Change default placeholder

      var nameFilter = document.querySelector(filter).closest('.woocommerce-widget-layered-nav').querySelector('form > input').name;

      if (!params.includes(nameFilter)) {
        var defaultPlaceholder = document.querySelector(".ss-main".concat(filter, " .placeholder"));
        var currentPlaceholder = document.querySelector(filter).closest('.woocommerce-widget-layered-nav').querySelector('.widgettitle').textContent;
        defaultPlaceholder.textContent = currentPlaceholder;
      }
    });
  }

  function sendForm(currentFilter) {
    var select = document.querySelector('.' + currentFilter.config.class[0]);
    select.submit();
  }
};